import React from "react";
import { useSync } from "../context/SyncContext";
import { Wifi, WifiOff, RefreshCw, CheckCircle2 } from "lucide-react";

export default function SyncIndicator() {
  const { online, pending, syncing } = useSync();

  let content;
  if (!online) {
    content = (
      <div data-testid="sync-offline" className="flex items-center gap-1.5 rounded-full bg-red-600 px-3 py-1.5 text-xs font-semibold text-white">
        <WifiOff className="h-3.5 w-3.5" />
        Offline{pending > 0 ? ` · ${pending} in coda` : ""}
      </div>
    );
  } else if (syncing || pending > 0) {
    content = (
      <div data-testid="sync-syncing" className="flex items-center gap-1.5 rounded-full bg-blue-600 px-3 py-1.5 text-xs font-semibold text-white">
        <RefreshCw className="h-3.5 w-3.5 animate-spin-slow" />
        Sincronizzazione{pending > 0 ? ` · ${pending}` : "…"}
      </div>
    );
  } else {
    content = (
      <div data-testid="sync-synced" className="flex items-center gap-1.5 rounded-full bg-emerald-600/90 px-3 py-1.5 text-xs font-semibold text-white">
        <CheckCircle2 className="h-3.5 w-3.5" />
        Sincronizzato
      </div>
    );
  }
  return content;
}
